// Defense against open-redirect attacks on post-auth navigation.
// Any redirect target sourced from a query string, an API response, or
// otherwise outside the bundle must pass through here before being
// handed to react-router's navigate().
//
// Reject:
//   - protocol-relative URLs (`//evil.com/path`)
//   - absolute URLs with a scheme (`https://evil.com`, `javascript:alert(1)`)
//   - anything that doesn't start with `/`
//   - backslashes, which some browsers normalise to `/` in URL parsing
//     and would let `/\\evil.com` slip past a naive prefix check
export function isSafeRedirectPath(target: unknown): target is string {
  if (typeof target !== 'string') return false;
  if (target.length === 0) return false;
  if (!target.startsWith('/')) return false;
  if (target.startsWith('//')) return false;
  if (target.startsWith('/\\')) return false;
  if (target.includes('\\')) return false;
  return true;
}

export function safeRedirectOrDefault(
  target: unknown,
  fallback: string,
): string {
  return isSafeRedirectPath(target) ? target : fallback;
}
